import {defineStore} from 'pinia';

export const useSurfaceEditorStore = defineStore('surfaceEditorStore', () => {
  const conf = ref({});
  const project = ref(null);
  const surfaces = ref([]);

  function setConf(c) {
    conf.value = c;
  }

  const statesManagement = useSurfaceEditorStoreStatesManagement({surfaces, project});
  const {
    pauseUndo,
    resumeUndo,
    commitUndo,
    clearUndoHistory
  } = statesManagement;

  const selectionManagement = useSurfaceEditorStoreSelection({surfaces});
  const {selectElement, editElement, setActiveSurface, clearSelection, clearActiveSurface} = selectionManagement;

  const positionGuidesEnabled = ref(true);
  function togglePositionGuides() {
    positionGuidesEnabled.value = !positionGuidesEnabled.value;
  }

  const resizeManagement = useSurfaceEditorStoreResize({surfaces, pauseUndo, resumeUndo, commitUndo, positionGuidesEnabled});

  const projectModule = useSurfaceEditorStoreProject({
    conf,
    project,
    surfaces,
    selectElement,
    editElement,
    clearSelection,
    setActiveSurface,
    pauseUndo,
    resumeUndo,
    commitUndo,
    clearUndoHistory,
    cancelActiveInteraction: resizeManagement.cancelActiveInteraction
  });

  const scaleManagement = useSurfaceEditorStoreScaleManagement({surfaces});
  const {scale} = scaleManagement;

  const contextualPanel = useSurfaceEditorStoreContextualPanel();
  const contextMenu = useSurfaceEditorStoreContextMenu({surfaces, selectElement});
  const templates = useSurfaceEditorStoreTemplates();

  const isSliderDragging = ref(false);
  function setSliderDragging(value) {
    isSliderDragging.value = value;
  }

  const getScaledElementPositionStyle = ({element, hAdjustment = 0, includeRotation = true}) => ({
    width: `${element.width * scale.value}px`,
    height: `${(element.height + hAdjustment) * scale.value}px`,
    transform: `translate(${element.x * scale.value}px, ${element.y * scale.value}px)${includeRotation ? ` rotate(${element.rotation || 0}deg)`: ''}`,
    transformOrigin: '50% 50%'
  });

  function clear() {
    clearSelection();
    clearActiveSurface();
    contextualPanel.closeContextualPanel();
    contextMenu.closeContextMenu();

    project.value = null;
    surfaces.value = [];
    conf.value = {};
    clearUndoHistory();
    templates.clearTemplates();
  }

  return {
    conf,
    setConf,

    project,
    surfaces,
    ...projectModule,
    ...statesManagement,
    ...scaleManagement,
    ...selectionManagement,
    ...resizeManagement,
    ...contextualPanel,
    ...contextMenu,
    ...useSurfaceEditorStoreUIPositioning(),
    ...useSurfaceEditorStoreDataResources(),
    ...templates,
    positionGuidesEnabled,
    togglePositionGuides,
    isSliderDragging,
    setSliderDragging,

    getScaledElementPositionStyle,

    clear
  };
});
